import _ from "lodash";
import { useEffect, useState } from "react";
import { useLocation, withRouter } from "react-router-dom";

import { getAuthenticatedRoutes } from "@/utils/authenticatedRoutes";
import { getChallengeRoutes } from "@/utils/challengeRoutes";
import { getUnauthenticatedRoutes } from "@/utils/unauthenticatedRoutes";

const RouterFactory = (props) => {
  const [routerProps, setRouterProps] = useState(_.cloneDeep(props));
  const { search } = useLocation();

  useEffect(() => {
    setRouterProps(props);
  }, [props]);

  useEffect(() => {
    try {
      const pattern = "\\bpatientName\\b|\\bemail\\b";

      if (search && search.match(pattern)) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        const queryString = Object.keys(params)
          .filter((param) => !param.match(pattern))
          .map((key) => key + "=" + params[key])
          .join("&");

        const newLocation = queryString
          ? window.location.pathname + `?${queryString}`
          : window.location.pathname;

        props.history.push(newLocation);
      }
    } catch (e) {
      console.log(e);
    }
  }, [search]);

  const allowRedirect =
    window.location.pathname === "/" ||
    window.location.pathname === "/app" ||
    window.location.pathname === "/app/home" ||
    window.location.pathname === "/auth" ||
    window.location.pathname === "/auth/sign-in" ||
    window.location.pathname === "/auth/sign-up" ||
    window.location.pathname === "/auth/challenge" ||
    !window.localStorage.getItem("token");

  const authState = routerProps.auth.role
    ? "authenticated"
    : routerProps.auth.challengeName
      ? "challenge"
      : "unauthenticated";

  switch (authState) {
    case "authenticated":
      return getAuthenticatedRoutes(routerProps);

    case "challenge":
      return getChallengeRoutes(allowRedirect, routerProps);

    default:
      return getUnauthenticatedRoutes(allowRedirect, routerProps);
  }
};

export default withRouter(RouterFactory);
